export const load = () => ({
	h1: 'Soundproof Your Home with Window Inserts',
	title: 'Soundproof Your Home with Window Inserts',
	description:
		"Turn your home into a sanctuary from outside noise with soundproofing Indow window inserts. Don't replace your windows and instead simply press window inserts into your window frames, blocking 50 to 70% of the noise that is bothering you.",
	showTitle: true,
});
